/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const upload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.344 7.671 8 4.993m0 0 2.656 2.678M8 4.993V13.5M3 2h10"
    />
  </svg>
)
export default upload
